var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "confirm-info", style: { height: _vm.viewportHeight } },
    [
      _c("HomeHeader", { attrs: { "scroll-top": "300" } }),
      _c("div", { staticClass: "flex-column container w-wrapper" }, [
        _c("div", { staticClass: "flex-column main" }, [
          _c("div", { staticClass: "title" }, [_vm._v("企业MCN机构申请")]),
          _c(
            "div",
            { staticClass: "steps-box" },
            [
              _c(
                "el-steps",
                { attrs: { active: 3, "align-center": "" } },
                [
                  _c("el-step", { attrs: { title: "选择公会类型" } }),
                  _c("el-step", { attrs: { title: "填写公会信息" } }),
                  _c("el-step", { attrs: { title: "填写资质信息" } }),
                  _c("el-step", { attrs: { title: "确认信息" } }),
                  _c("el-step", { attrs: { title: "等待审核" } }),
                  _c("el-step", { attrs: { title: "完成入驻" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "form-box" }, [
            _c("div", { staticClass: "right-info" }, [
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("企业类型")]
                ),
                _c("div", { staticClass: "right-info-item-value" }, [
                  _vm.applyDetail.mcnType === 1
                    ? _c("span", [_vm._v("企业")])
                    : _vm.applyDetail.mcnType === 2
                    ? _c("span", [_vm._v("个人")])
                    : _c("span", [_vm._v("未知")]),
                ]),
              ]),
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("负责人姓名")]
                ),
                _c("div", { staticClass: "right-info-item-value" }, [
                  _vm._v(_vm._s(_vm.applyDetail.contactName)),
                ]),
              ]),
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("负责人身份")]
                ),
                _c("div", { staticClass: "right-info-item-value" }, [
                  _vm.applyDetail.contactRole === 1
                    ? _c("span", [_vm._v("无")])
                    : _vm.applyDetail.contactRole === 2
                    ? _c("span", [_vm._v("区县代理人")])
                    : _vm.applyDetail.contactRole === 3
                    ? _c("span", [_vm._v("市级代理人")])
                    : _vm.applyDetail.contactRole === 4
                    ? _c("span", [_vm._v("省级代理人")])
                    : _vm._e(),
                ]),
              ]),
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("手机号码")]
                ),
                _c("div", { staticClass: "right-info-item-value" }, [
                  _vm._v(_vm._s(_vm.applyDetail.contactPhone)),
                ]),
              ]),
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("身份证照片")]
                ),
                _c(
                  "div",
                  { staticClass: "right-info-item-value" },
                  [
                    _c("el-image", {
                      staticClass: "id-card-img",
                      attrs: {
                        fit: "contain",
                        src: _vm.applyDetail.contactIdCardFrontUrl,
                        "preview-src-list": [
                          _vm.applyDetail.contactIdCardFrontUrl,
                          _vm.applyDetail.contactIdCardBackUrl,
                        ],
                      },
                    }),
                    _c("el-image", {
                      staticClass: "id-card-img",
                      attrs: {
                        fit: "contain",
                        src: _vm.applyDetail.contactIdCardBackUrl,
                        "preview-src-list": [
                          _vm.applyDetail.contactIdCardBackUrl,
                        ],
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("身份证号码")]
                ),
                _c("div", { staticClass: "right-info-item-value" }, [
                  _vm._v(_vm._s(_vm.applyDetail.contactIdCard)),
                ]),
              ]),
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("公会名称")]
                ),
                _c("div", { staticClass: "right-info-item-value" }, [
                  _vm._v(_vm._s(_vm.applyDetail.orgName)),
                ]),
              ]),
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("公会介绍")]
                ),
                _c("div", { staticClass: "right-info-item-value" }, [
                  _vm._v(_vm._s(_vm.applyDetail.orgDescription)),
                ]),
              ]),
              _vm.applyDetail.mcnType === 1
                ? _c("div", { staticClass: "flex-row right-info-item-col" }, [
                    _c(
                      "div",
                      { staticClass: "flex-center-row right-info-item-label" },
                      [_vm._v("公司营业执照")]
                    ),
                    _c(
                      "div",
                      { staticClass: "right-info-item-value" },
                      [
                        _c("el-image", {
                          staticClass: "id-card-img",
                          attrs: {
                            src: _vm.applyDetail.businessLicenseUrl,
                            "preview-src-list": [
                              _vm.applyDetail.businessLicenseUrl,
                            ],
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.applyDetail.mcnType === 1
                ? _c("div", { staticClass: "flex-row right-info-item-col" }, [
                    _c(
                      "div",
                      { staticClass: "flex-center-row right-info-item-label" },
                      [_vm._v("企业名称")]
                    ),
                    _c("div", { staticClass: "right-info-item-value" }, [
                      _vm._v(_vm._s(_vm.applyDetail.businessLicenseName)),
                    ]),
                  ])
                : _vm._e(),
              _vm.applyDetail.mcnType === 1
                ? _c("div", { staticClass: "flex-row right-info-item-col" }, [
                    _c(
                      "div",
                      { staticClass: "flex-center-row right-info-item-label" },
                      [_vm._v("营业性演出许可证")]
                    ),
                    _c(
                      "div",
                      { staticClass: "right-info-item-value" },
                      _vm._l(_vm.applyDetail.otherLicenseList, function (item) {
                        return _c("el-image", {
                          key: item,
                          staticClass: "id-card-img",
                          attrs: {
                            fit: "cover",
                            src: item,
                            "preview-src-list":
                              _vm.applyDetail.otherLicenseList,
                          },
                        })
                      }),
                      1
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("签约主播数量")]
                ),
                _c("div", { staticClass: "right-info-item-value" }, [
                  _vm._v(_vm._s(_vm.applyDetail.anchorAmount)),
                ]),
              ]),
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("签约主播证明材料")]
                ),
                _c(
                  "div",
                  { staticClass: "right-info-item-value" },
                  _vm._l(
                    _vm.applyDetail.anchorEvidentiaryList,
                    function (item) {
                      return _c("el-image", {
                        key: item,
                        staticClass: "id-card-img",
                        attrs: {
                          fit: "cover",
                          src: item,
                          "preview-src-list":
                            _vm.applyDetail.anchorEvidentiaryList,
                        },
                      })
                    }
                  ),
                  1
                ),
              ]),
              _c("div", { staticClass: "flex-row right-info-item-col" }, [
                _c(
                  "div",
                  { staticClass: "flex-center-row right-info-item-label" },
                  [_vm._v("签约主播来源")]
                ),
                _c("div", { staticClass: "right-info-item-value" }, [
                  _vm._v(_vm._s(_vm.applyDetail.anchorSource)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "footer-btn" }, [
              _vm.applyDetail.status === 4
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "delete-reason" }, [
                        _vm._v(
                          "您的账号已注销，注销原因：" +
                            _vm._s(_vm.applyDetail.reason)
                        ),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "500px" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm()
                            },
                          },
                        },
                        [_vm._v("重新申请 ")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 12 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { type: "default" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goStepTwo()
                                    },
                                  },
                                },
                                [_vm._v("上一步 ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitForm()
                                    },
                                  },
                                },
                                [_vm._v("确认无误，提交入驻审核 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }